import React, {useEffect, useState} from "react";
import axios from "axios";
import Swal from "sweetalert2";
import ERPDataGrid from "../ERPDataGrid";
import "../ERPTheme.css";
import {baseUrl, ipAddress, userName,} from "../Univ";
import "bootstrap/dist/css/bootstrap.min.css";
function Workflow() {
    const [loading, setLoading] = useState(false);
    const [workflows, setWorkflows] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [formData, setFormData] = useState({
        id: "",
        workflow_name: "",
        document_type: "",
        description: "",
        is_active: true,
        addedby: userName,
        ip_add: ipAddress,
    });
    const workflowMaster = [{
        workflow_name: "Farmer Registration", document_type: "UserProfile"
    }, {
        workflow_name: "Inventory Transfer", document_type: "InventoryTransfer"
    }, {
        workflow_name: "Purchase Order", document_type: "PurchaseOrder"
    }, {
        workflow_name: "Warehouse Receipt", document_type: "WarehouseReceipt"
    }, {
        workflow_name: "Warehouse Dispatch", document_type: "WarehouseDispatch"
    }, {
        workflow_name: "Machine Booking", document_type: "MachineBooking"
    }, {
        workflow_name: "Machine Service", document_type: "MachineService"
    }, {
        workflow_name: "Equipment Rental", document_type: "EquipmentRental"
    }, {
        workflow_name: "Sales Order", document_type: "SalesOrder"
    }, {
        workflow_name: "Purchase Return", document_type: "PurchaseReturn"
    }, {
        workflow_name: "Sales Return", document_type: "SalesReturn"
    }, {
        workflow_name: "Farmer Loan", document_type: "FarmerLoan"
    }, {
        workflow_name: "Insurance Claim", document_type: "InsuranceClaim"
    }, {
        workflow_name: "Land Lease", document_type: "LandLease"
    }, {
        workflow_name: "Warehouse Transfer", document_type: "WarehouseTransfer"
    }];
    useEffect(() => {
        getWorkflow();
    }, []);
    const getWorkflow = () => {
        setLoading(true);
        axios
            .get(baseUrl + "workflow/")
            .then((res) => {
                setWorkflows(res.data);
                setLoading(false);
            })
            .catch(() => {
                setLoading(false);
                Swal.fire("Error", "Unable to load workflows", "error");
            });
    };
    const handleChange = (e) => {
        const {name, value} = e.target;
        if (name === "workflow_name") {
            const selected = workflowMaster.find(x => x.workflow_name === value);
            setFormData({
                ...formData, workflow_name: value, document_type: selected ? selected.document_type : ""
            });
        } else {
            setFormData({
                ...formData, [name]: value
            });
        }
    };
    const openAddModal = () => {
        setFormData({
            id: "",
            workflow_name: "",
            document_type: "",
            description: "",
            is_active: true,
            addedby: userName,
            ip_add: ipAddress,
        });
        setShowModal(true);
    };
    const closeModal = () => {
        setShowModal(false);
    };
    const saveWorkflow = () => {
        const data = new FormData();
        data.append("workflow_name", formData.workflow_name);
        data.append("document_type", formData.document_type);
        data.append("description", formData.description);
        data.append("is_active", formData.is_active);
        data.append("addedby", userName);
        data.append("ip_add", ipAddress);
        setLoading(true);
        if (formData.id) {
            axios
                .put(baseUrl + `workflow/${formData.id}/`, data)
                .then(() => {
                    Swal.fire("Success", "Workflow updated successfully", "success");
                    closeModal();
                    getWorkflow();
                })
                .catch(() => {
                    Swal.fire("Error", "Unable to update workflow", "error");
                });
        } else {
            axios
                .post(baseUrl + "workflow/", data)
                .then(() => {
                    Swal.fire("Success", "Workflow created successfully", "success");
                    closeModal();
                    getWorkflow();
                })
                .catch(() => {
                    Swal.fire("Error", "Unable to save workflow", "error");
                });
        }
    };
    const editWorkflow = (row) => {
        setFormData({
            id: row.id,
            workflow_name: row.workflow_name,
            document_type: row.document_type,
            description: row.description || "",
            is_active: row.is_active,
            addedby: userName,
            ip_add: ipAddress,
        });
        setShowModal(true);
    };
    const deleteWorkflow = (id) => {
        Swal.fire({
            title: "Delete Workflow?",
            text: "This action cannot be reversed",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Delete",
        })
            .then((result) => {
                if (result.isConfirmed) {
                    axios
                        .delete(`workflow/${id}/`)
                        .then(() => {
                            Swal.fire("Deleted", "Workflow removed", "success");
                            getWorkflow();
                        });
                }
            });
    };
    const columns = [{
        field: "id", headerName: "ID", width: 80,
    }, {
        field: "workflow_name", headerName: "Workflow Name", flex: 1,
    }, {
        field: "document_type", headerName: "Document Type", flex: 1,
    }, {
        field: "description", headerName: "Description", flex: 2,
    }, {
        field: "is_active",
        headerName: "Status",
        width: 120,
        renderCell: (params) => (params.value ? <span className="badge bg-success">
                        Active
                    </span> : <span className="badge bg-danger">
                        Inactive
                    </span>)
    }, {
        field: "action", headerName: "Action", width: 180, renderCell: (params) => (<>

                <button

                    className="btn btn-sm btn-primary me-2"

                    onClick={() => editWorkflow(params.row)}

                >

                    Edit

                </button>


                <button

                    className="btn btn-sm btn-danger"

                    onClick={() => deleteWorkflow(params.row.id)}

                >

                    Delete

                </button>


            </>)
    }];
    return (<div className="container-fluid mt-3">


            <div className="card shadow">


                <div className="card-header bg-primary text-white d-flex justify-content-between">


                    <h5 className="mb-0">

                        Workflow Master

                    </h5>


                    <button

                        className="btn btn-light"

                        onClick={openAddModal}

                    >

                        + Add Workflow

                    </button>


                </div>


                <div className="card-body">


                    <div
                        style={{
                            height: 600, width: "100%"
                        }}
                    >


                        <ERPDataGrid

                            rows={workflows}

                            columns={columns}

                            loading={loading}

                            getRowId={(row) => row.id}

                            pageSizeOptions={[10, 25, 50, 100]}


                            disableRowSelectionOnClick

                        />


                    </div>


                </div>


            </div>


            {showModal && (<div

                    className="modal fade show"

                    style={{
                        display: "block", backgroundColor: "rgba(0,0,0,.5)"
                    }}

                >


                    <div

                        className="modal-dialog modal-lg modal-dialog-centered"

                    >


                        <div className="modal-content">


                            <div className="modal-header">


                                <h5 className="modal-title">

                                    {formData.id ? "Edit Workflow" : "Add Workflow"}

                                </h5>


                                <button

                                    className="btn-close"

                                    onClick={closeModal}

                                />


                            </div>


                            <div className="modal-body">


                                <div className="row">


                                    <div className="col-md-6 mb-3">

                                        <label>Workflow Name</label>

                                        <select
                                            className="form-select"
                                            name="workflow_name"
                                            value={formData.workflow_name}
                                            onChange={handleChange}
                                        >

                                            <option value="">
                                                Select Workflow
                                            </option>

                                            {workflowMaster.map((w, i) => (<option
                                                    key={i}
                                                    value={w.workflow_name}
                                                >
                                                    {w.workflow_name}
                                                </option>))}

                                        </select>

                                    </div>

                                    <div className="col-md-6 mb-3">

                                        <label>Document Type</label>

                                        <input
                                            className="form-control"
                                            value={formData.document_type}
                                            readOnly
                                        />

                                    </div>

                                    <div className="col-md-12 mb-3">


                                        <label>
                                            Description
                                        </label>


                                        <textarea

                                            className="form-control"

                                            rows="3"

                                            name="description"

                                            value={formData.description}

                                            onChange={handleChange}

                                        />


                                    </div>


                                    <div className="col-md-12">


                                        <div className="form-check">


                                            <input

                                                className="form-check-input"

                                                type="checkbox"

                                                name="is_active"

                                                checked={formData.is_active}

                                                onChange={handleChange}

                                            />

                                            <label className="form-check-label">

                                                Active

                                            </label>


                                        </div>


                                    </div>


                                </div>


                            </div>


                            <div className="modal-footer">


                                <button

                                    className="btn btn-secondary"

                                    onClick={closeModal}

                                >

                                    Close

                                </button>


                                <button

                                    className="btn btn-success"

                                    onClick={saveWorkflow}

                                >

                                    Save

                                </button>


                            </div>


                        </div>


                    </div>


                </div>)}


        </div>);
}
export default Workflow;